export const liveMatches = [
  {
    id: "match-1",
    homeTeam: "皇家马德里",
    awayTeam: "巴塞罗那",
    homeLogo: "https://readdy.ai/api/search-image?query=Real%20Madrid%20football%20club%20crest%20emblem%20white%20and%20gold%20on%20transparent%20background%20clean%20simple%20logo&width=80&height=80&seq=match-logo-rm&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=FC%20Barcelona%20football%20club%20crest%20emblem%20red%20blue%20yellow%20on%20transparent%20background%20clean%20simple%20logo&width=80&height=80&seq=match-logo-barca&orientation=squarish",
    homeScore: 2,
    awayScore: 1,
    status: "live",
    minute: "76'",
    league: "西甲",
    viewers: "238万",
  },
  {
    id: "match-2",
    homeTeam: "湖人",
    awayTeam: "勇士",
    homeLogo: "https://readdy.ai/api/search-image?query=Los%20Angeles%20Lakers%20basketball%20team%20logo%20purple%20gold%20on%20transparent%20background%20clean%20simple&width=80&height=80&seq=match-logo-lakers&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Golden%20State%20Warriors%20basketball%20team%20logo%20blue%20gold%20on%20transparent%20background%20clean%20simple&width=80&height=80&seq=match-logo-warriors&orientation=squarish",
    homeScore: 98,
    awayScore: 102,
    status: "live",
    minute: "Q4 3:22",
    league: "NBA",
    viewers: "516万",
  },
  {
    id: "match-3",
    homeTeam: "曼城",
    awayTeam: "阿森纳",
    homeLogo: "https://readdy.ai/api/search-image?query=Manchester%20City%20football%20club%20crest%20emblem%20blue%20white%20on%20transparent%20background%20clean%20simple%20logo&width=80&height=80&seq=match-logo-manc&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Arsenal%20football%20club%20crest%20emblem%20red%20white%20on%20transparent%20background%20clean%20simple%20logo&width=80&height=80&seq=match-logo-ars&orientation=squarish",
    homeScore: 0,
    awayScore: 0,
    status: "upcoming",
    minute: "20:00",
    league: "英超",
    viewers: "189万",
  },
  {
    id: "match-4",
    homeTeam: "德约科维奇",
    awayTeam: "阿尔卡拉斯",
    homeLogo: "https://readdy.ai/api/search-image?query=Serbian%20tennis%20player%20abstract%20logo%20minimal%20clean%20simple%20on%20transparent%20background&width=80&height=80&seq=match-logo-djok&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Spanish%20tennis%20player%20abstract%20logo%20minimal%20clean%20simple%20on%20transparent%20background&width=80&height=80&seq=match-logo-alc&orientation=squarish",
    homeScore: 1,
    awayScore: 2,
    status: "live",
    minute: "第三盘 4-3",
    league: "温网",
    viewers: "128万",
  },
  {
    id: "match-5",
    homeTeam: "拜仁慕尼黑",
    awayTeam: "多特蒙德",
    homeLogo: "https://readdy.ai/api/search-image?query=Bayern%20Munich%20football%20club%20crest%20emblem%20red%20white%20on%20transparent%20background%20clean%20simple%20logo&width=80&height=80&seq=match-logo-bay&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Borussia%20Dortmund%20football%20club%20crest%20emblem%20yellow%20black%20on%20transparent%20background%20clean%20simple%20logo&width=80&height=80&seq=match-logo-dort&orientation=squarish",
    homeScore: 3,
    awayScore: 1,
    status: "finished",
    minute: "全场",
    league: "德甲",
    viewers: "156万",
  },
];

export const categories = [
  { slug: "football", name: "足球", icon: "ri-football-line", count: 128 },
  { slug: "basketball", name: "篮球", icon: "ri-basketball-line", count: 86 },
  { slug: "tennis", name: "网球", icon: "ri-base-station-line", count: 42 },
  { slug: "esports", name: "电竞", icon: "ri-gamepad-line", count: 63 },
  { slug: "f1", name: "F1赛车", icon: "ri-steering-2-line", count: 18 },
  { slug: "boxing", name: "拳击", icon: "ri-boxing-line", count: 15 },
  { slug: "golf", name: "高尔夫", icon: "ri-golf-ball-line", count: 12 },
  { slug: "comprehensive", name: "综合", icon: "ri-medal-line", count: 55 },
];

export const articles = [
  {
    id: "article-1",
    title: "欧冠决赛前瞻：皇马与曼城的巅峰对决，谁能笑到最后？",
    excerpt: "本赛季欧冠决赛即将在伊斯坦布尔打响，皇马与曼城两支欧洲顶级豪门将展开终极对决。双方实力接近，战术风格迥异，这场比赛注定将载入史册。",
    category: "football",
    categoryName: "足球",
    image: "https://readdy.ai/api/search-image?query=European%20Champions%20League%20final%20football%20stadium%20epic%20atmosphere%20dramatic%20lighting%20professional%20sports%20photography%20wide%20angle%20stadium%20packed%20with%20fans%20green%20pitch&width=800&height=450&seq=article-football-1&orientation=landscape",
    author: "王涛",
    date: "2026-08-08",
    time: "10:32",
    readCount: "12.8万",
    commentCount: 356,
    tags: ["欧冠", "皇马", "曼城", "决赛"],
    content: `<p>北京时间8月8日凌晨3点，2025-26赛季欧冠决赛将在土耳其伊斯坦布尔的阿塔图尔克奥林匹克体育场打响。皇家马德里与曼彻斯特城这两支欧洲足坛的顶级豪门，将在万众瞩目之下展开终极对决。</p>
    <h2>皇马：欧冠之王的底蕴</h2>
    <p>皇家马德里作为欧冠历史上最成功的俱乐部，已经14次捧起大耳朵杯。本赛季他们在安切洛蒂的带领下，一路淘汰了巴黎圣日耳曼、拜仁慕尼黑等强敌，展现出了强大的韧性和冠军气质。</p>
    <p>锋线上，姆巴佩与维尼修斯的双箭头组合本赛季合力打进58球，是欧洲最令人胆寒的攻击组合。中场莫德里奇和贝林厄姆的搭档，既有经验又有活力。后防线在米利唐和吕迪格的带领下也愈发稳固。</p>
    <h2>曼城：瓜迪奥拉的传控美学</h2>
    <p>曼城在瓜迪奥拉的执教下，已经成为了欧洲最具统治力的球队之一。哈兰德本赛季各项赛事打进42球，状态火热。中场的德布劳内和福登的组合，在创造力和执行力上都达到了顶级水准。</p>
    <p>曼城本赛季在英超提前三轮夺冠，展现出了极强的统治力。他们的传控打法已经臻于化境，任何对手在面对他们时都会感到窒息般的压迫感。</p>
    <h2>战术博弈：速度与控制的较量</h2>
    <p>本场比赛最大的看点在于两种截然不同风格的碰撞。皇马擅长快速反击，利用姆巴佩和维尼修斯的速度撕开对手防线。而曼城则更喜欢通过耐心的传导控制比赛节奏。</p>
    <p>数据显示，曼城本赛季场均控球率达到67.8%，而皇马的场均控球率为54.2%。但皇马的反击效率极高，平均每3.2次反击就能转化为一次射门机会。</p>
    <h2>关键对位</h2>
    <p>哈兰德 vs 吕迪格：挪威神锋将在禁区内面对德国铁卫的严密盯防。哈兰德本赛季在欧冠已经打进11球，而吕迪格场均完成2.8次抢断和4.5次解围。</p>
    <p>德布劳内 vs 贝林厄姆：两位世界级中场的对决将直接影响比赛的走向。德布劳内本赛季欧冠助攻8次，贝林厄姆则贡献了5球4助攻。</p>`,
  },
  {
    id: "article-2",
    title: "NBA季后赛：湖人逆转勇士，詹姆斯砍下40+三双创造历史",
    excerpt: "在NBA西部半决赛关键战中，湖人队在主场以118比112逆转战胜勇士队。詹姆斯全场砍下42分11篮板10助攻的豪华三双数据，成为NBA历史上首位在季后赛中多次砍下40+三双的球员。",
    category: "basketball",
    categoryName: "篮球",
    image: "https://readdy.ai/api/search-image?query=NBA%20playoff%20basketball%20game%20intense%20action%20player%20dunking%20dramatic%20arena%20lighting%20professional%20sports%20photography%20crowd%20roaring%20fast%20action&width=800&height=450&seq=article-basketball-1&orientation=landscape",
    author: "李明",
    date: "2026-08-07",
    time: "14:20",
    readCount: "9.6万",
    commentCount: 218,
    tags: ["NBA", "湖人", "勇士", "詹姆斯"],
    content: `<p>北京时间8月7日，NBA西部半决赛第三场比赛在洛杉矶斯台普斯中心打响。湖人队在最多落后18分的情况下，凭借詹姆斯的神奇发挥，以118比112逆转战胜勇士队，系列赛总比分2比1领先。</p>
    <h2>詹姆斯：不老传奇再创纪录</h2>
    <p>本场比赛，勒布朗·詹姆斯出战41分钟，28投16中，三分球9投4中，罚球8罚6中，砍下42分11篮板10助攻3抢断的超级三双数据。这是詹姆斯职业生涯第3次在季后赛中砍下40+三双，超越东契奇和约基奇，独占NBA历史第一。</p>
    <p>值得一提的是，詹姆斯在第四节独得18分，包括在最后3分钟内连续命中两记关键三分球，彻底浇灭了勇士反扑的希望。赛后詹姆斯表示："我只是想在主场球迷面前打出最好的表现，我们的目标是总冠军。"</p>
    <h2>勇士：库里孤掌难鸣</h2>
    <p>勇士方面，斯蒂芬·库里全场25投12中，三分球14投7中，得到35分5篮板8助攻。但除库里之外，勇士其他球员手感冰冷，汤普森15投仅4中得到10分，普尔12投3中得到8分。</p>
    <p>勇士主帅科尔赛后坦言："我们在防守端犯了一些错误，特别是在第四节，让詹姆斯太容易地找到了进攻节奏。我们需要在下一场比赛中做出调整。"</p>`,
  },
  {
    id: "article-3",
    title: "温网男单决赛：德约科维奇与阿尔卡拉斯的新老天王对决",
    excerpt: "温布尔登网球锦标赛男单决赛将在德约科维奇与阿尔卡拉斯之间展开。这将是新老两代天王的巅峰对决，德约科维奇将冲击个人第25座大满贯冠军。",
    category: "tennis",
    categoryName: "网球",
    image: "https://readdy.ai/api/search-image?query=Wimbledon%20tennis%20championship%20grass%20court%20professional%20player%20serving%20dramatic%20lighting%20sports%20photography%20green%20grass%20white%20outfit%20summer%20tournament&width=800&height=450&seq=article-tennis-1&orientation=landscape",
    author: "张伟",
    date: "2026-08-07",
    time: "09:15",
    readCount: "7.3万",
    commentCount: 189,
    tags: ["温网", "德约科维奇", "阿尔卡拉斯", "网球"],
    content: `<p>2026年温布尔登网球锦标赛男单决赛即将在中央球场打响。塞尔维亚天王诺瓦克·德约科维奇将迎战西班牙新星卡洛斯·阿尔卡拉斯，这将是新老两代天王的巅峰对决。</p>
    <h2>德约科维奇：冲击第25冠</h2>
    <p>如果德约科维奇能够赢下这场决赛，他将获得个人第25座大满贯单打冠军，超越玛格丽特·考特的24冠纪录，独享网坛历史第一人的称号。本赛季德约科维奇状态出色，在澳网和法网已经两度夺冠。</p>
    <h2>阿尔卡拉斯：新时代的领军人</h2>
    <p>年仅23岁的阿尔卡拉斯已经拥有3座大满贯冠军，被认为是后三巨头时代最具统治力的球员。他的暴力正手和出色移动能力在草地赛场上同样具有巨大威胁。</p>`,
  },
  {
    id: "article-4",
    title: "中超联赛：上海申花3比1击败北京国安，登顶积分榜",
    excerpt: "中超联赛第18轮焦点战，上海申花在虹口足球场3比1击败北京国安，凭借这场胜利反超上海海港登顶积分榜首位。",
    category: "football",
    categoryName: "足球",
    image: "https://readdy.ai/api/search-image?query=Chinese%20Super%20League%20football%20match%20Shanghai%20stadium%20red%20jersey%20players%20celebrating%20goal%20professional%20sports%20photography%20evening%20stadium%20lights&width=800&height=450&seq=article-football-2&orientation=landscape",
    author: "刘洋",
    date: "2026-08-06",
    time: "22:45",
    readCount: "15.2万",
    commentCount: 432,
    tags: ["中超", "上海申花", "北京国安"],
    content: `<p>北京时间8月6日晚，中超联赛第18轮焦点战在虹口足球场打响。上海申花主场迎战北京国安，最终以3比1的比分取得胜利，成功登顶积分榜。</p>
    <h2>比赛回顾</h2>
    <p>上半场第23分钟，申花外援马莱莱接到曹赟定的精准传中，头球破门为球队首开纪录。第38分钟，国安通过角球机会由张玉宁扳平比分。</p>
    <p>下半场申花加强攻势。第58分钟，特谢拉禁区外远射破门再次超出比分。第82分钟，替补登场的于汉超锁定胜局。</p>`,
  },
  {
    id: "article-5",
    title: "F1摩纳哥大奖赛：维斯塔潘杆位夺冠，红牛包揽前二",
    excerpt: "F1摩纳哥大奖赛正赛在蒙特卡洛赛道落下帷幕，红牛车队车手维斯塔潘以杆位出发，全程领跑，轻松夺得本赛季第六个分站冠军。",
    category: "f1",
    categoryName: "F1赛车",
    image: "https://readdy.ai/api/search-image?query=Formula%201%20Monaco%20Grand%20Prix%20racing%20car%20speeding%20through%20street%20circuit%20dramatic%20motion%20blur%20professional%20motorsport%20photography%20sunny%20day%20Monte%20Carlo&width=800&height=450&seq=article-f1-1&orientation=landscape",
    author: "赵刚",
    date: "2026-08-06",
    time: "16:30",
    readCount: "4.1万",
    commentCount: 87,
    tags: ["F1", "摩纳哥", "维斯塔潘", "红牛"],
    content: `<p>F1摩纳哥大奖赛正赛在历史悠久的蒙特卡洛赛道落下帷幕，红牛车队的维斯塔潘以统治级表现夺得冠军，队友佩雷兹获得亚军，红牛车队包揽前两名。</p>
    <h2>维斯塔潘：无可撼动的统治力</h2>
    <p>从周六排位赛拿下杆位开始，维斯塔潘就展现出了无可撼动的统治力。正赛中他从第一圈开始就建立了领先优势，最终以超过10秒的优势率先冲线。</p>`,
  },
  {
    id: "article-6",
    title: "LOL全球总决赛：BLG击败T1夺冠，中国战队三连冠",
    excerpt: "英雄联盟全球总决赛在首尔落幕，BLG战队以3比1击败韩国T1战队，成功卫冕冠军。这是中国战队连续第三年称霸英雄联盟世界赛。",
    category: "esports",
    categoryName: "电竞",
    image: "https://readdy.ai/api/search-image?query=Esports%20League%20of%20Legends%20grand%20final%20arena%20filled%20with%20fans%20stage%20with%20screens%20dramatic%20lighting%20esports%20competition%20professional%20photography%20crowd%20roaring&width=800&height=450&seq=article-esports-1&orientation=landscape",
    author: "陈晓",
    date: "2026-08-05",
    time: "23:50",
    readCount: "28.6万",
    commentCount: 1256,
    tags: ["LOL", "BLG", "T1", "全球总决赛"],
    content: `<p>2026英雄联盟全球总决赛在韩国首尔高尺天空巨蛋落下帷幕，来自中国LPL赛区的BLG战队以3比1击败韩国LCK赛区的T1战队，成功捧起召唤师杯。</p>
    <h2>创造历史的三连冠</h2>
    <p>这是中国LPL赛区连续第三年夺得全球总决赛冠军，创造了赛区历史。BLG中单选手Knight凭借出色发挥，荣膺总决赛MVP。</p>`,
  },
  {
    id: "article-7",
    title: "英超新赛季前瞻：六强争霸格局已定，谁将问鼎？",
    excerpt: "英超2026-27赛季即将拉开帷幕，曼城、阿森纳、利物浦、曼联、切尔西和纽卡斯尔六支球队实力相近，本赛季的争冠格局将异常激烈。",
    category: "football",
    categoryName: "足球",
    image: "https://readdy.ai/api/search-image?query=English%20Premier%20League%20football%20stadium%20aerial%20view%20packed%20stadium%20green%20pitch%20professional%20sports%20photography%20sunny%20day%20dramatic%20clouds%20grand%20atmosphere&width=800&height=450&seq=article-football-3&orientation=landscape",
    author: "王涛",
    date: "2026-08-05",
    time: "11:00",
    readCount: "18.3万",
    commentCount: 567,
    tags: ["英超", "曼城", "阿森纳", "新赛季"],
    content: `<p>英超2026-27赛季即将于本周六正式开战，新一轮的冠军争夺即将上演。本赛季六大豪门的实力空前接近，堪称近年来最具悬念的英超赛季。</p>
    <h2>曼城：卫冕冠军的底气</h2>
    <p>作为过去四个赛季的英超冠军，曼城依然是本赛季夺冠的最大热门。瓜迪奥拉的球队在夏季转会窗口继续补强，哈兰德和德布劳内的核心框架保持完整。</p>`,
  },
  {
    id: "article-8",
    title: "拳击世纪之战：乌西克与富里的重量级统一战",
    excerpt: "备受瞩目的重量级拳王统一战将在伦敦温布利体育场上演，乌克兰拳王乌西克将与英国拳王富里展开重量级四大组织拳王金腰带的终极争夺。",
    category: "boxing",
    categoryName: "拳击",
    image: "https://readdy.ai/api/search-image?query=Professional%20boxing%20match%20heavyweight%20championship%20ring%20dramatic%20lighting%20boxing%20arena%20intense%20atmosphere%20sports%20photography%20two%20fighters%20facing%20off&width=800&height=450&seq=article-boxing-1&orientation=landscape",
    author: "孙强",
    date: "2026-08-04",
    time: "19:20",
    readCount: "6.8万",
    commentCount: 203,
    tags: ["拳击", "乌西克", "富里", "重量级"],
    content: `<p>拳击界期待已久的重量级四大组织拳王统一战即将在伦敦温布利体育场上演。现任WBA、IBF、WBO重量级拳王奥列克桑德尔·乌西克将迎战WBC重量级拳王泰森·富里。</p>
    <h2>乌西克：技术流大师</h2>
    <p>乌西克以出色的脚步移动和精准的打击著称，他的业余拳击生涯极其辉煌，曾获得奥运会金牌。转为职业拳手后，他一路高歌猛进，统一了次重量级后升入重量级继续统治。</p>`,
  },
];

export const featuredNews = [
  {
    id: "featured-1",
    title: "中国男足世预赛：主场2比0击败日本，出线形势大好",
    category: "football",
    categoryName: "足球",
    image: "https://readdy.ai/api/search-image?query=Chinese%20national%20football%20team%20celebrating%20goal%20red%20jersey%20stadium%20filled%20with%20fans%20dramatic%20emotion%20professional%20sports%20photography%20night%20stadium&width=600&height=340&seq=featured-football-1&orientation=landscape",
    date: "2026-08-08",
    tag: "热门",
  },
  {
    id: "featured-2",
    title: "NBA选秀大会：中国球员杨瀚森首轮第8顺位被马刺选中",
    category: "basketball",
    categoryName: "篮球",
    image: "https://readdy.ai/api/search-image?query=NBA%20draft%20young%20Chinese%20basketball%20player%20on%20stage%20with%20team%20cap%20excited%20smile%20arena%20background%20professional%20photography&width=600&height=340&seq=featured-basketball-1&orientation=landscape",
    date: "2026-08-08",
    tag: "热点",
  },
  {
    id: "featured-3",
    title: "巴黎奥运会倒计时：中国代表团备战情况全面解读",
    category: "comprehensive",
    categoryName: "综合",
    image: "https://readdy.ai/api/search-image?query=Olympic%20Games%20preparation%20Chinese%20athletes%20training%20facility%20modern%20sports%20complex%20professional%20photography%20bright%20lighting%20athletic%20atmosphere&width=600&height=340&seq=featured-olympics-1&orientation=landscape",
    date: "2026-08-07",
    tag: "奥运",
  },
];

export const hotScores = [
  { league: "英超", match: "曼联 vs 利物浦", score: "2:2", status: "下半场 68'" },
  { league: "西甲", match: "巴萨 vs 马竞", score: "1:0", status: "上半场 32'" },
  { league: "NBA", match: "凯尔特人 vs 雄鹿", score: "88:85", status: "Q3 5:12" },
  { league: "中超", match: "山东泰山 vs 武汉三镇", score: "0:0", status: "上半场 15'" },
  { league: "意甲", match: "AC米兰 vs 尤文图斯", score: "1:1", status: "下半场 52'" },
  { league: "法甲", match: "巴黎圣日耳曼 vs 里昂", score: "3:0", status: "下半场 74'" },
];

export const aboutStats = [
  { label: "日均活跃用户", value: "580万+", icon: "ri-user-line" },
  { label: "覆盖赛事", value: "200+", icon: "ri-trophy-line" },
  { label: "合作媒体", value: "50+", icon: "ri-newspaper-line" },
  { label: "日均资讯发布", value: "3000+", icon: "ri-article-line" },
];

export const aboutMilestones = [
  { year: "2018", title: "极速体育正式上线", description: "以足球赛事直播和资讯为核心，正式面向体育爱好者开放。" },
  { year: "2019", title: "用户突破100万", description: "凭借极速流畅的直播体验和专业的赛事分析，用户规模快速增长。" },
  { year: "2020", title: "全运动品类覆盖", description: "从足球扩展至篮球、网球、电竞、F1等全运动品类。" },
  { year: "2021", title: "AI智能推荐上线", description: "推出基于人工智能的个性化内容推荐系统。" },
  { year: "2022", title: "日活突破500万", description: "成为国内领先的体育资讯平台之一。" },
  { year: "2023", title: "获得B轮融资", description: "完成2亿美元B轮融资，估值超过15亿美元。" },
  { year: "2024", title: "全球赛事直播覆盖", description: "与国际体育组织达成合作，直播覆盖全球200+赛事。" },
  { year: "2025", title: "推出8K超清直播", description: "行业首次推出8K超高清赛事直播技术。" },
  { year: "2026", title: "AI赛事预测上线", description: "基于大数据和深度学习的赛事预测功能正式发布。" },
];

export const faqData = [
  {
    question: "极速体育的直播延迟是多少？",
    answer: "极速体育采用先进的CDN加速和低延迟传输技术，确保赛事直播延迟控制在3秒以内，部分重点赛事甚至可以实现1秒以内的超低延迟，让您享受到近乎实时的观赛体验。",
  },
  {
    question: "如何在极速体育上观看赛事直播？",
    answer: "您可以通过极速体育官网或下载极速体育App，注册账号后即可免费观看大部分赛事直播。部分高清和超高清赛事需要订阅VIP会员服务。",
  },
  {
    question: "极速体育覆盖哪些体育项目？",
    answer: "极速体育目前覆盖足球、篮球、网球、电竞、F1赛车、拳击、高尔夫、综合格斗等超过50个体育项目，涵盖全球200+顶级赛事，满足不同体育迷的需求。",
  },
  {
    question: "极速体育的会员价格是多少？",
    answer: "极速体育提供多种会员方案：月度会员29元/月，季度会员69元/季，年度会员199元/年。会员可享受高清直播、去广告、专属资讯等特权服务。",
  },
  {
    question: "如何联系极速体育的客服团队？",
    answer: "您可以通过以下方式联系我们：客服电话400-888-8888（7×24小时），客服邮箱support@jisusports.com，或在App内使用在线客服功能。我们会在第一时间为您解决问题。",
  },
];